var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"splash-container",attrs:{"id":"vanta"}},[_c('router-view')],1),_c('div',{staticClass:"footer"},[_vm._v("© Sidharth Patnaik")])])}
var staticRenderFns = []

export { render, staticRenderFns }